
<template>
    
        <mars-view class="inline-flex-box-inline"><template v-if="(componentsFrom === 'home-card' || componentsFrom === 'local-card' || componentsFrom === 'home') && lawyerInfo.lawyer_tag"><mars-image v-if="lawyerInfo.lawyer_tag === '明星律师'" class="lawyer-name-content-logo star" :class="isAndroid ? 'carefull-lawyer-item-title-logo-scale' : ''" src="https://lvlin-base.cdn.bcebos.com/law/pages/new-home/square/star-lawyer.png"></mars-image><mars-image v-else-if="lawyerInfo.lawyer_tag === '严选'" class="lawyer-name-content-logo vip" :class="isAndroid ? 'carefull-lawyer-item-title-logo-scale' : ''" :src="lawyerInfo.vip_type === 7 ?
                'https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/young-vip-member.png' :
                'https://lvlin-base.cdn.bcebos.com/law/pages/new-home/square/vip-lawyer.png'"></mars-image><mars-image v-else-if="lawyerInfo.lawyer_tag === 'V标'" class="lawyer-name-content-logo" :class="isAndroid ? 'carefull-lawyer-item-title-logo-scale' : ''" src="https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png"></mars-image></template><template v-if="(componentsFrom === 'case-detail' || componentsFrom === 'firm-detail') && lawyerInfo.lawyer_tag"><mars-image v-if="lawyerInfo.lawyer_tag === '严选'" class="lawyer-yanxuan" :src="lawyerInfo.vip_type === 7 ?
                'https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/young-vip-member.png' :
                'https://lvlin-base.cdn.bcebos.com/law/pages/iknowqa/lawyer-vip.png'"></mars-image></template></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */

export default {
  props: {
    componentsFrom: {
      type: String,
      default: ''
    },
    lawyerInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      isAndroid: false
    };
  },
  computed: {},
  mounted() {
    let u = this.$api.getSystemInfoSync().system;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    this.isAndroid = isAndroid;
  }
};
</script>

<style scoped>
.inline-flex-box {
  width: 100%;
  display: inline-flex;
}
.inline-flex-box-inline {
  display: inline-flex;
}
.carefull-lawyer-item-title-logo {
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
  vertical-align: text-top;
  margin: 0 0.04rem;
}
.lawyer-name-content-logo {
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
  margin-left: 5px;
  transform: translateY(-1px);
}
.star {
  min-width: 69px;
  min-height: 18px;
  max-width: 69px;
  max-height: 18px;
}
.vip {
  min-width: 50px;
  min-height: 18px;
  max-width: 50px;
  max-height: 18px;
  transform: translateY(0);
}
.carefull-lawyer-item-title-logo-scale {
  transform: scale(0.9);
  transform-origin: center center;
}
.lawyer-yanxuan {
  width: 0.46rem;
  height: 0.17rem;
  margin-left: 0.07rem;
  margin-top: -0.015rem;
}
.main-content-lawyer-list-item-name-icon {
  display: inline-block;
  width: 0.59rem;
  height: 0.22rem;
  background: url('https://lvlin-base.cdn.bcebos.com/pc/home/vip-zunxiang-icon.png') no-repeat;
  background-size: 100% 100%;
  margin-left: 0.02rem;
  margin-top: -0.04rem;
  vertical-align: middle;
  transform: translateY(0.04rem);
}
.main-content-lawyer-list-item-name-icon-notVip {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/young-vip-member.png') no-repeat;
  background-size: 100% 100%;
  margin-top: -0.01rem;
}

</style>
